import React from "react";
import clsx from "clsx";

type BodyTextProps = {
  children: React.ReactNode;
  className?: string;
};

const Typography = ({ children, className }: BodyTextProps) => {
  // NB do not set colours here, it would interfere with cascading theming across components
  return <p className={clsx("text-medium leading-normal font-medium", className)}>{children}</p>;
};

export default Typography;